var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedallaTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 41,
    viewBox: "0 0 28 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_1931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9186 9.60465L5.86047 3.15116L12.1395 1.05814V7.27907C12.4027 8.87711 12.628 9.59506 13.1279 10.6512C10.5446 10.9863 9.22401 11.4911 7.0814 12.9186C6.43032 11.9573 6.22452 11.274 5.9186 9.60465Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1395 9.54651L22.1977 3.09302L15.9186 1V7.22093C15.6554 8.81897 15.4301 9.53692 14.9302 10.593C17.5136 10.9282 18.8341 11.4329 20.9767 12.8605C21.6278 11.8992 21.8336 11.2158 22.1395 9.54651Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.8605C8.47715 12.8605 4 17.3376 4 22.8605C4 25.8408 5.30378 28.5166 7.37209 30.3487L8.70123 28.0858C7.37603 26.7421 6.55814 24.8968 6.55814 22.8605C6.55814 18.7504 9.88997 15.4186 14 15.4186C14.6872 15.4186 15.3527 15.5118 15.9845 15.6861L17.314 13.4227C16.2768 13.0585 15.1615 12.8605 14 12.8605Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 32.8605C19.5228 32.8605 24 28.3833 24 22.8605C24 18.4992 21.208 14.79 17.314 13.4227L15.9845 15.6861C19.1311 16.5546 21.4419 19.4377 21.4419 22.8605C21.4419 26.9705 18.11 30.3023 14 30.3023C11.9263 30.3023 10.0507 29.4542 8.70123 28.0858L7.37209 30.3487C9.13658 31.9116 11.4575 32.8605 14 32.8605Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 30.3023C18.11 30.3023 21.4419 26.9705 21.4419 22.8605C21.4419 19.4377 19.1311 16.5546 15.9845 15.6861L8.70123 28.0858C10.0507 29.4542 11.9263 30.3023 14 30.3023Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.4186C9.88997 15.4186 6.55814 18.7504 6.55814 22.8605C6.55814 24.8968 7.37603 26.7421 8.70123 28.0858L15.9845 15.6861C15.3527 15.5118 14.6872 15.4186 14 15.4186Z",
    fill: "#838383"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8267 28V27.088L14.2987 23.236C14.4827 22.948 14.6507 22.68 14.8027 22.432C14.9627 22.184 15.0907 21.924 15.1867 21.652C15.2907 21.372 15.3427 21.052 15.3427 20.692C15.3427 20.244 15.2707 19.892 15.1267 19.636C14.9827 19.38 14.7307 19.252 14.3707 19.252C14.0667 19.252 13.8307 19.336 13.6627 19.504C13.4947 19.672 13.3787 19.892 13.3147 20.164C13.2507 20.436 13.2187 20.728 13.2187 21.04V21.364H11.9347V21.028C11.9347 20.444 12.0107 19.944 12.1627 19.528C12.3227 19.104 12.5747 18.776 12.9187 18.544C13.2707 18.312 13.7347 18.196 14.3107 18.196C15.0947 18.196 15.6787 18.42 16.0627 18.868C16.4467 19.308 16.6387 19.92 16.6387 20.704C16.6387 21.12 16.5867 21.484 16.4827 21.796C16.3867 22.108 16.2587 22.4 16.0987 22.672C15.9387 22.944 15.7627 23.224 15.5707 23.512L13.3387 26.92H16.4107V28H11.8267Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_1931",
    x: 0,
    y: 1,
    width: 28,
    height: 39.8605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_1931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_1931",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallaTwo);
export default __webpack_public_path__ + "static/media/medallaTwo.390db06db1ab4c873fcbcabf7c969f81.svg";
export { ForwardRef as ReactComponent };